const comments = [
  {
    text: '资源真的很全，在别的平台找不到的老片这里都有，画质也很棒！聚合了神马影视和樱花影视的资源，太方便了。',
    name: '小明',
    avatar: 'ri-user-line',
    role: '资深影迷',
  },
  {
    text: '更新速度没得说，热播剧同步更新，再也不用到处找资源了。小小影视和久久影视的内容这里都能直接看。',
    name: '小红',
    avatar: 'ri-user-line',
    role: '追剧达人',
  },
  {
    text: '界面简洁好用，聚合了多个平台的资源，选源很方便。飘花影视和丫丫影视的片子都在这里找到了。',
    name: '小华',
    avatar: 'ri-user-line',
    role: '普通用户',
  },
  {
    text: '免费高清真的很良心，推荐给了很多朋友，都说好用。琪琪影视和蚂蚁影视的资源也都能搜到，太全面了。',
    name: '小丽',
    avatar: 'ri-user-line',
    role: '忠实用户',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            用户评价
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            听听用户们怎么说
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6">
          {comments.map((comment, i) => (
            <div
              key={i}
              className="bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6"
            >
              <div className="flex items-center gap-1 mb-3">
                {[...Array(5)].map((_, j) => (
                  <i key={j} className="ri-star-fill text-sm text-accent-500"></i>
                ))}
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                &ldquo;{comment.text}&rdquo;
              </p>
              <div className="flex items-center gap-3 pt-3 border-t border-background-200/60">
                <div className="w-9 h-9 rounded-full bg-primary-100 flex items-center justify-center">
                  <i className={`${comment.avatar} text-sm text-primary-600`}></i>
                </div>
                <div>
                  <div className="text-sm font-medium text-foreground-950">{comment.name}</div>
                  <div className="text-xs text-foreground-500">{comment.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}